import { Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from 'Components/Layout';
import { IWithWorksheetInjectedProps, WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import externalTestMethods from 'Components/Worksheets/ExternalTestMethods';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';

let BsEnIsoPreparationAsReceivedWaterContentSection: React.FC<IWithWorksheetInjectedProps> = ({
  createWorksheetSelector,
}) => {
  const asReceivedWaterContentDetermined = useSelector(
    pipe(createWorksheetSelector!('AsReceivedWaterContentDetermined'), valueOrDefault(false))
  );
  const importedAsReceivedWaterContentTestId = useSelector(
    createWorksheetSelector!('AssociatedAsReceivedWaterContent.ImportedTest.Id')
  );

  const noOversizeMaterial = useSelector(pipe(createWorksheetSelector!('NoOversizeMaterial'), valueOrDefault(false)));

  return (
    <SectionGroup heading="">
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          name="AsReceivedWaterContentDetermined"
          visible={noOversizeMaterial}
          options={[
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]}
        />
      </ListFieldSection>

      {(asReceivedWaterContentDetermined || !noOversizeMaterial) && (
        <WorksheetAssociatedTestSection
          heading="As Received Water Content"
          label="As-Received Water Content Determined By:"
          name="AssociatedAsReceivedWaterContent"
          testType="Moisture Content"
          associatedTestModel={{
            measured: true,
            imported: {
              importedTestResults: (
                <ListFieldSection>
                  <Field
                    input={<TextOutput />}
                    label="Water Content (%)"
                    name="AssociatedAsReceivedWaterContent.ImportedTest.Results.MoistureContentPercent"
                    emph
                  />
                </ListFieldSection>
              ),
              importModel: {
                Id: importedAsReceivedWaterContentTestId,
              },
            },
            external: {
              testMethods: [externalTestMethods.moistureContent.BS_EN_ISO_17892_1],
              permitOtherTestMethods: true,
              externalTestResults: (
                <ListFieldSection>
                  <Field
                    input={<NumericInput />}
                    label="As-Received Water Content (%)"
                    name="AssociatedAsReceivedWaterContent.ExternalTest.Results.MoistureContentPercent"
                  />
                </ListFieldSection>
              ),
            },
          }}
        />
      )}
    </SectionGroup>
  );
};

BsEnIsoPreparationAsReceivedWaterContentSection = withInjectedProps(BsEnIsoPreparationAsReceivedWaterContentSection);

export { BsEnIsoPreparationAsReceivedWaterContentSection };
export default BsEnIsoPreparationAsReceivedWaterContentSection;
